export enum SplitDocumentsStatus {
  SPLIT_INITIATED = 'Split_Initiated',
  SPLIT_STARTED = 'Split_Started',
  SPLIT_PROGRESS = 'Split_Progress',
  SPLIT_DONE = 'Split_Done',
  SPLITTER_DOCUMENTS_UPLOADING = 'Splitted_Documents_Uploading',
  DOCUMENT_UPLOAD_COMPLETED = 'Completed',
  SPLIT_ERROR = 'Split_Error',
  RESULT = 'RESULT'
}
